var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":_vm.filteredIcon.color,"stroke":_vm.filteredIcon.color,"width":_vm.width,"height":_vm.height,"viewBox":'0 0 ' + _vm.width + ' ' + _vm.height,"xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.filteredIcon.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }